//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        startDate: {
            type: String,
            required: true
        },
        endDate: {
            type: String,
            required: true
        },
        intervals: {
            type: Object,
            required: true
        },
        usertypes: {
            type: Object,
            required: true
        },
        states: {
            type: Object,
            required: true
        },
        schooltypes: {
            type: Object,
            required: true
        },
    },

    data () {
        return {
            filter: {
                interval: 'daily',
                date: [this.startDate, this.endDate],
                usertype: 'pupils',
                state: null,
                schooltype: null
            },
            exportLoading: false
        };
    },

    methods: {
        reloadWidgets () {
            this.$refs['minutes-played-chart'].loadData();
            this.$refs['planets-finished-chart'].loadData();
            this.$refs['new-users-chart'].loadData();
            this.$refs['active-users-chart'].loadData();
            this.$refs['total-schools-chart'].loadData();
        },

        exportInactiveClassrooms () {
            window.open(
                '/statistic/inactive-classrooms',
                '_blank'
            );
        },

        exportActiveUsers () {
            this.exportLoading = true;
            axios.get('statistic/active-users')
                .then(response => {
                    this.$message({
                        type: 'success',
                        message: response.data.message
                    });

                    this.exportLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    this.exportLoading = false;
                });
        }
    }
};
